module.exports = __webpack_public_path__ + "static/media/189.84bac62d.wav";